import { Container, Row } from "reactstrap";
import { ECommerce, PaymentDetails } from "../../../../constants";
import CreditCard from "./CreditCard";
import DebitCard from "./DebitCard";
import NetBanking from "./NetBanking";
import Cod from "./Cod";
import Emi from "./Emi";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

// This component is used to display the different payment methods available, including credit card, debit card, net banking, cash on delivery, and EMI.
const PaymentDetailsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={PaymentDetails} parent={ECommerce} />
      <Container fluid className="credit-card">
        <Row>
          <CreditCard />
          <DebitCard />
          <Cod />
          <Emi />
          <NetBanking />
        </Row>
      </Container>
    </>
  );
};

export default PaymentDetailsContainer;
